import { ContractUseCase } from '@unifiprotocol/core-sdk'
import { MultiSigContractMethods, TMultiSigParams } from './Types'

export class GetConfirmationsNumber extends ContractUseCase<MultiSigContractMethods, [], number> {
  constructor({ contractAddress }: TMultiSigParams) {
    super(contractAddress, MultiSigContractMethods.confirmationsNumber, [], false)
  }
}
